module.exports = __webpack_public_path__ + "img/start-test.5e1b10eb.svg";